import type { JSX } from 'react'

import type { BrandColor } from '@app-types/color'
import type { IconComponent } from '@components/icons/types'

/**
 * Renders a QRCode icon with a colorful border.
 */
export const QRCode: IconComponent<Props & JSX.IntrinsicElements['svg']> = ({
    color = 'step-midnight',
    secondaryColor = 'step-cyanora',
    width,
    height,
    ...restOfProps
}) => (
    <svg
        width={width}
        height={height}
        viewBox='0 0 40 41'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...restOfProps}
    >
        <rect x='1' y='1' width='37.5793' height='39' rx='5.04' fill='white' />
        <path
            d='M9.35369 8.96884C8.96965 8.96884 8.65796 9.29172 8.65796 9.68954V18.338C8.65796 18.7358 8.96965 19.0587 9.35369 19.0587H17.7025C18.0865 19.0587 18.3982 18.7358 18.3982 18.338V9.68954C18.3982 9.29172 18.0865 8.96884 17.7025 8.96884H9.35369ZM21.8768 8.96884C21.4928 8.96884 21.1811 9.29172 21.1811 9.68954V18.338C21.1811 18.7358 21.4928 19.0587 21.8768 19.0587H30.2256C30.6096 19.0587 30.9213 18.7358 30.9213 18.338V9.68954C30.9213 9.29172 30.6096 8.96884 30.2256 8.96884H21.8768ZM10.0494 10.4102H17.0067V17.6173H10.0494V10.4102ZM22.5726 10.4102H29.5299V17.6173H22.5726V10.4102ZM11.4409 11.8517V16.1759H15.6153V11.8517H11.4409ZM23.964 11.8517V16.1759H28.1384V11.8517H23.964ZM9.35369 21.9415C8.96965 21.9415 8.65796 22.2644 8.65796 22.6622V31.3106C8.65796 31.7085 8.96965 32.0313 9.35369 32.0313H17.7025C18.0865 32.0313 18.3982 31.7085 18.3982 31.3106V22.6622C18.3982 22.2644 18.0865 21.9415 17.7025 21.9415H9.35369ZM21.8768 21.9415C21.4928 21.9415 21.1811 22.2644 21.1811 22.6622V26.2657H22.5726V23.3829H25.3555V21.9415H21.8768ZM27.4427 21.9415C27.0586 21.9415 26.747 22.2644 26.747 22.6622V26.2657H28.1384V23.3829H30.9213V21.9415H27.4427ZM10.0494 23.3829H17.0067V30.5899H10.0494V23.3829ZM11.4409 24.8243V29.1485H15.6153V24.8243H11.4409ZM23.964 26.2657V27.7071H23.2683C22.8843 27.7071 22.5726 28.03 22.5726 28.4278V32.0313H23.964V29.1485H25.3555V32.0313H26.747V28.4278C26.747 28.03 26.4353 27.7071 26.0512 27.7071H25.3555V26.2657H23.964ZM29.5299 26.2657V32.0313H30.9213V26.2657H29.5299Z'
            fill={`var(--${color})`}
        />
        <rect
            x='1'
            y='1'
            width='37.5793'
            height='39'
            rx='5.04'
            stroke={`var(--${secondaryColor})`}
            strokeWidth='2'
        />
    </svg>
)

interface Props {
    color?: BrandColor
    secondaryColor?: BrandColor
}
